'use client';

import { useState, useEffect, useRef } from 'react';
import LoadingOverlay from './LoadingOverlay';
import Sidebar from './Sidebar';
import TopNav from './TopNav';
import { usePathname } from 'next/navigation';
import { signIn } from 'next-auth/react';

interface ClientLayoutProps {
  children: React.ReactNode;
  session: any;
}

export default function ClientLayout({ children, session }: ClientLayoutProps) {
  const [isLoading, setIsLoading] = useState(true);
  const signInTriggered = useRef(false);

  //Dont show sidebar and topnav on login page
  const pathname = usePathname();
  const loginPage = pathname === "/login";

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (session?.error === 'RefreshAccessTokenError' && !signInTriggered.current) {
      signInTriggered.current = true;
      // Fixed callbackUrl so repeated re-auths don't nest-encode window.location.href into itself.
      signIn(undefined, { callbackUrl: '/' });
    }
  }, [session]);

  return (
    <>
      <LoadingOverlay isLoading={isLoading} />
      <div style={{ display: isLoading ? 'none' : 'flex', height: '100vh' }}>
        {!loginPage && <Sidebar />}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            {!loginPage && <TopNav session={session} />}
              <div style={{ flex: 1, overflow: 'auto', padding: loginPage ? '0' : '10px',  maxWidth: '100%' }}>
                <div id="page-header">
                  <div id="menu-bar" className="menu-bar" />
                </div>
                {children}
              </div>
          </div>
      </div>
    </>
  );
} 